import { Center, Image, Text } from "@chakra-ui/react";
import React from "react";
import { useParams } from "react-router-dom";
import { LoadingText } from "../../components/Loader/Spinner";
import { NO_IMAGE_AVAILABLE } from "../../helpers/environment";
import { useFindPaymentQR } from "../../services/hooks/base";

export default function PaymentQrPage() {
  const { code } = useParams();

  // * Get param to get the QR code
  const { isFetching, data } = useFindPaymentQR({
    payload: code,
    config: { enabled: !!code },
  });

  return (
    <Center w="100vw" h="100vh">
      {isFetching ? (
        <LoadingText />
      ) : data && data.status ? (
        <Image src={data.message} h="100vh" objectFit="cover" overflow="hidden" opacity="0" transition="opacity 0.5s ease-in-out" onLoad={(e) => (e.target.style.opacity = "1")} onError={(e) => (e.target.src = NO_IMAGE_AVAILABLE)} />
      ) : (
        <Text fontSize="lg" color="gray.600" fontWeight="medium">
          រកមិនឃើញ!
        </Text>
      )}
    </Center>
  );
}
